<template>
  <VMenu rounded>
    <template #activator="{ props }">
      <VBtn v-bind="props" icon rounded="false" class="button-medium">
        <PersonAvatar
          :first-name="userFullName.firstName"
          :last-name="userFullName.lastName"
          type="user"
        />
      </VBtn>
    </template>

    <VCard class="pt-2 pb-2 mt-1 elevation-1" width="240">
      <VBtn
        data-testid="user-menu-settings-button"
        :to="{ name: routeNames.USER_PROFILE }"
        variant="text"
        :active="false"
        class="text-body-1 w-full justify-start"
        :disabled="disabled"
      >
        <template #prepend>
          <VIcon icon="person" class="mr-7 opacity-60" />
        </template>
        {{ t('Account') }}
      </VBtn>

      <VBtn
        v-if="isHandoverAvailable"
        data-testid="user-menu-handover-button"
        :to="{ name: routeNames.LOGOUT_HANDOVER }"
        variant="text"
        :active="false"
        class="text-body-1 w-full justify-start"
        :disabled="disabled"
      >
        <template #prepend>
          <VIcon icon="turn_right" class="mr-7 opacity-60" />
        </template>
        {{ t('Consultation Handover') }}
      </VBtn>

      <VBtn
        data-testid="user-menu-logout-button"
        variant="text"
        :active="false"
        class="button-medium text-body-1 w-full justify-start"
        :disabled="disabled"
        @click="onLogoutClick"
      >
        <template #prepend>
          <VIcon icon="power_settings_new" class="mr-7 opacity-60" />
        </template>
        {{ t('Logout') }}
      </VBtn>
    </VCard>
  </VMenu>

  <LogoutModal v-model="isLogoutModalOpen" v-if="isLogoutModalOpen" />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import PersonAvatar from '@/components/navigation/PersonAvatar.vue'
import { routeNames } from '@/router/routeNames'
import { useUserStore } from '@/stores/user'
import { usePluginsStore } from '@/stores/plugins'
import { AuthenticationService } from '@/services/AuthenticationService'
import LogoutModal from '@/components/navigation/LogoutModal.vue'
import useHandoverAvailability from '@/composables/useHandoverAvailability'

interface FullName {
  firstName: string
  lastName: string
}

withDefaults(
  defineProps<{
    disabled?: boolean
  }>(),
  {
    disabled: false
  }
)

const { t } = useI18n()
const { isConnectEnabled } = storeToRefs(usePluginsStore())
const { isHandoverAvailable } = useHandoverAvailability()
const isLogoutModalOpen = ref(false)

const userFullName = computed<FullName>(() => {
  const userData = useUserStore().user

  return {
    firstName: userData?.firstName ?? '',
    lastName: userData?.lastName ?? ''
  }
})

async function onLogoutClick() {
  if (isConnectEnabled.value) {
    isLogoutModalOpen.value = true
  } else {
    await AuthenticationService.logout()
  }
}
</script>
